import React from 'react'
import HammerIcon from '@tecuity/sos-icons/react/hammer-solid'

export const ComponentUnderConstruction = () => {
    return (
      <div style={{paddingTop: '50px'}}>
        <HammerIcon style={{width: '100%', height: '230px', margin: 'auto'}}/>
        <div style={{fontWeight: 'bolder', fontSize: 16, textAlign: 'center'}}>Component Under Construction</div>
      </div>
    )
  }

export default ComponentUnderConstruction;